import cofee from "../images/popular/cofee.PNG";
import ferrerorocher from "../images/popular/ferrero-rocher.png";
import icecream from "../images/popular/ice-cream.png";
import shampoo from "../images/popular/shampoo.png";
import soup from "../images/popular/soup.png";
import trimmer from "../images/popular/trimmer.png";
import waffer from "../images/popular/waffer.png";

export const popular = [
  {
    id: 21,
    name: "Cofee",
    image: cofee,
    price: 45,
    description:
      "Start your day right with the first sip of this classic that awakens your senses to new opportunities",
    discount: 4,
    category: "Beverages",
  },
  {
    id: 22,
    name: "Ferrero Rocher",
    image: ferrerorocher,
    description:
      "Ferrero Rocher, the golden experience in a box of 24 premium pralines",
    price: 120,
    discount: 35,
    category: "Milk products",
  },
  {
    id: 23,
    name: "Ice Cream",
    image: icecream,
    price: 140,
    description:
      "Amul Real milk vanilla ice cream now in a tub that enough for all your friends. The classics never go out of the fashion.",
    discount: 17,
    category: "Milk products",
  },
  {
    id: 24,
    name: "WOW Shampoo",
    image: shampoo,
    price: 390,
    description:
      "Get strong and lustrous hair with WOW Skin Science Onion Black Seed Oil Shampoo",
    discount: 15,
    category: "Beauty products",
  },
  {
    id: 25,
    name: "Knorr Soup",
    image: soup,
    price: 30,
    description:
      "Knorr has hand-picked the best quality vegetables and mixed it with spices to make delicious Knorr Sweet Corn Chicken Soup",
    discount: 2,
    category: "Beauty products",
  },
  {
    id: 26,
    name: "Trimmer",
    image: trimmer,
    discount: 50,
    price: 700,
    description:
      "Philips MG7715 Multi-Grooming Kit For Men Cordless Grooming Kit for Men (Silver, Black)",
    category: "Beauty products",
  },
  {
    id: 27,
    name: "Waffer",
    image: waffer,
    price: 10,
    description: "Sizzling Barbeque Flavour, 30g Pouch",
    discount: 1,
    category: "Food products",
  },
];
